var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import valuesIn from 'lodash/valuesIn';
import { useIsMobile } from '@repo/mui-config/hooks';
import { colorPalette } from '@repo/mui-config/color-palette';
import { smsCodeInputFieldNames } from '@repo/shared/constants';
import { SmsCodeInputMask } from './masks/sms-code-input-mask';
var getFieldsValue = function (inputRef, index) {
    var _a, _b, _c;
    return (_c = (_b = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a[index]) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : '';
};
export function SmsCode(_a) {
    var isSmsCodeError = _a.isSmsCodeError;
    var isMobile = useIsMobile();
    var _b = useFormContext(), errors = _b.formState.errors, trigger = _b.trigger;
    var inputsRef = useRef([]);
    var setInputFocus = function (index) {
        var _a, _b;
        var value = getFieldsValue(inputsRef, index);
        if (value === '' && index > 0) {
            var prevInput = (_a = inputsRef.current) === null || _a === void 0 ? void 0 : _a[index - 1];
            if (prevInput)
                prevInput.focus();
        }
        else if (value !== '' && index < smsCodeInputFieldNames.length - 1) {
            var nextInput = (_b = inputsRef.current) === null || _b === void 0 ? void 0 : _b[index + 1];
            if (nextInput)
                nextInput.focus();
        }
    };
    var setInputBackground = function (error, value) {
        if (error) {
            return colorPalette.error.light;
        }
        else if (value) {
            return colorPalette.primary.light;
        }
        return 'none';
    };
    var renderErrorMessage = function () {
        var _a;
        var smsCodeErrors = valuesIn(errors.smsCode);
        return (_a = smsCodeErrors.find(function (item) { return Boolean(item.message); })) === null || _a === void 0 ? void 0 : _a.message;
    };
    return (_jsxs(_Fragment, { children: [_jsx(Grid, { columns: 14, container: true, justifyContent: "center", spacing: { xs: 1, md: 2 }, children: smsCodeInputFieldNames.map(function (fieldName, index) { return (_jsx(Grid, { size: 2, children: _jsx(Controller, { "data-testid": "smsCode.".concat(fieldName), name: "smsCode.".concat(fieldName), render: function (_a) {
                            var field = _a.field, fieldState = _a.fieldState;
                            return (_jsx(TextField, __assign({}, field, { slotProps: {
                                    input: {
                                        // @ts-expect-error Issue with the component types, more info here: https://github.com/s-yadav/react-number-format/issues/805,
                                        // official example with any https://codesandbox.io/p/sandbox/vigorous-zhukovsky-5m7nxt?file=%2Fsrc%2FDemo.tsx%3A89%2C1-90%2C1
                                        inputComponent: SmsCodeInputMask,
                                        style: {
                                            borderRadius: '10px',
                                        },
                                    },
                                    htmlInput: {
                                        'data-testid': "sms-code-input-".concat(index),
                                        maxLength: 1,
                                        style: {
                                            borderRadius: '10px',
                                            background: setInputBackground(fieldState.error, field.value),
                                            textAlign: 'center',
                                            fontSize: '24px',
                                            fontWeight: 500,
                                            padding: 0,
                                            width: isMobile ? '34px' : '42px',
                                            maxHeight: isMobile ? '54px' : '60px',
                                            minHeight: isMobile ? '54px' : '60px',
                                        },
                                    },
                                }, error: Boolean(fieldState.error), inputRef: function (el) {
                                    if (el) {
                                        inputsRef.current[index] = el;
                                    }
                                }, onChange: function (event) {
                                    field.onChange(event.target.value);
                                    isSmsCodeError && void trigger('smsCode');
                                    if (getFieldsValue(inputsRef, index) !== '') {
                                        setInputFocus(index);
                                    }
                                }, onFocus: function (e) {
                                    e.currentTarget.select();
                                }, onKeyDown: function (e) {
                                    if (e.key === 'Backspace' && getFieldsValue(inputsRef, index) === '') {
                                        setInputFocus(index);
                                    }
                                    if (e.key === getFieldsValue(inputsRef, index)) {
                                        setInputFocus(index);
                                        e.preventDefault();
                                    }
                                }, variant: "outlined" })));
                        } }) }, "smsCode[".concat(fieldName, "]"))); }) }), errors.smsCode ? (_jsx(Typography, { align: "left", color: "error", "data-testid": "sms-code-input-error", sx: { marginTop: '8px' }, children: renderErrorMessage() })) : null] }));
}
